import { companyInfo, transportInfo } from "@/mocks/homeData";

export default function ContactSection() {
  return (
    <section id="contact" className="relative w-full bg-navy-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="animate-on-scroll text-center mb-12 md:mb-16">
            <p className="text-sky-500 text-sm font-semibold tracking-wider uppercase mb-3">
              Contact Us
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-navy-900">
              연락처
            </h2>
            <p className="text-navy-500 text-sm md:text-base mt-3 max-w-xl mx-auto">
              궁금한 점이 있으시면 언제든지 연락주세요
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
            <div className="animate-on-scroll delay-100 space-y-6">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="bg-white rounded-xl p-5 border border-navy-100">
                  <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mb-3">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-phone-line text-sky-500 text-lg" />
                    </div>
                  </div>
                  <p className="text-xs text-navy-400 mb-1">대표 전화</p>
                  <a href={`tel:${companyInfo.phone}`} className="text-sm font-bold text-navy-900 hover:text-sky-600 transition-colors">
                    {companyInfo.phone}
                  </a>
                </div>

                <div className="bg-white rounded-xl p-5 border border-navy-100">
                  <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mb-3">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-smartphone-line text-sky-500 text-lg" />
                    </div>
                  </div>
                  <p className="text-xs text-navy-400 mb-1">담당자 연락</p>
                  <div className="space-y-1">
                    <a href={`tel:${companyInfo.mobile}`} className="block text-sm font-bold text-navy-900 hover:text-sky-600 transition-colors">
                      {companyInfo.mobile}
                    </a>
                    <a href={`tel:${companyInfo.mobile2}`} className="block text-sm font-bold text-navy-900 hover:text-sky-600 transition-colors">
                      {companyInfo.mobile2}
                    </a>
                  </div>
                </div>

                <div className="bg-white rounded-xl p-5 border border-navy-100">
                  <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mb-3">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-mail-line text-sky-500 text-lg" />
                    </div>
                  </div>
                  <p className="text-xs text-navy-400 mb-1">이메일</p>
                  <a href={`mailto:${companyInfo.email}`} className="text-sm font-bold text-navy-900 hover:text-sky-600 transition-colors break-all">
                    {companyInfo.email}
                  </a>
                </div>

                <div className="bg-white rounded-xl p-5 border border-navy-100">
                  <div className="w-10 h-10 bg-sky-100 rounded-lg flex items-center justify-center mb-3">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-map-pin-line text-sky-500 text-lg" />
                    </div>
                  </div>
                  <p className="text-xs text-navy-400 mb-1">주소</p>
                  <p className="text-sm font-bold text-navy-900 leading-snug">
                    {companyInfo.address}
                  </p>
                </div>
              </div>

              <div className="bg-navy-900 rounded-xl p-5 md:p-6 text-white">
                <h3 className="text-base font-bold mb-4 flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-bus-line text-sky-300" />
                  </div>
                  오시는 길
                </h3>
                <div className="space-y-3">
                  <div>
                    <p className="text-xs text-white/50 mb-1">대중교통</p>
                    <p className="text-sm text-white/80">{transportInfo.bus}</p>
                  </div>
                  <div>
                    <p className="text-xs text-white/50 mb-1">자가용</p>
                    <p className="text-sm text-white/80">{transportInfo.car}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="animate-on-scroll delay-200">
              <div className="rounded-xl overflow-hidden border border-navy-100 h-full min-h-[300px] md:min-h-[400px]">
                <iframe
                  title="회사 위치"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3213.724309802746!2d127.446275!3d36.354167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35654b5e1c1c1c1c%3A0x1c1c1c1c1c1c1c1c!2z64yA7KCE6rSR7Jet7IucIOykkeq1rCDtlYTrj5kg7ZWY7Jq47JuU65Sw!5e0!3m2!1sko!2skr!4v1700000000000"
                  width="100%"
                  height="100%"
                  style={{ border: 0, minHeight: '100%' }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="w-full h-full"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
